import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '073漫画网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '073漫画网是一个专注于少年漫画在线免费阅读的中文漫画平台，提供蜜桃少年漫画等热门作品的在线阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '在073漫画网阅读漫画需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。073漫画网所有漫画内容均为在线免费阅读，用户无需支付任何费用即可畅享海量漫画资源。',
        },
      },
      {
        '@type': 'Question',
        name: '073漫画网有哪些漫画类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '073漫画网涵盖少年漫画、热血漫画、校园漫画、奇幻漫画、冒险漫画、搞笑漫画、科幻漫画、悬疑漫画、恋爱漫画、动作漫画等多种类型，满足不同读者的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        name: '073漫画网的漫画多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '073漫画网每日更新漫画内容，确保读者能够第一时间阅读到最新的蜜桃少年漫画章节。我们的更新频率稳定，从不间断。',
        },
      },
    ],
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于073漫画网 - 蜜桃少年漫画在线免费阅读',
    description: '了解073漫画网的品牌故事、口碑评价和联系方式。专注于少年漫画在线免费阅读的中文漫画平台。',
    url: 'http://tangcruises.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '073漫画网',
      url: 'http://tangcruises.com/',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://tangcruises.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'http://tangcruises.com/about',
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-10">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-6 mb-8 text-center">
              关于073漫画网
            </h1>

            <section className="max-w-4xl mx-auto mb-14">
              <div className="text-center mb-8">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                  在<strong>073漫画网</strong>，我们致力于为漫画爱好者打造一个优质的<strong>漫画在线免费阅读</strong>平台。无论你是<strong>蜜桃少年漫画</strong>的忠实读者，还是想探索更多类型的少年漫画，073漫画网都能满足你的阅读需求。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-colors">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500">
                    <i className="ri-book-open-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">海量资源</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    收录超过10,000部漫画作品，涵盖各种类型，每日更新不断，让读者畅享阅读乐趣。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-colors">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-50 text-accent-500">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">高清画质</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    采用高清扫描技术，确保每一页漫画都清晰细腻，为读者带来最佳的阅读体验。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-colors">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-secondary-50 text-secondary-500">
                    <i className="ri-heart-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">完全免费</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    073漫画网所有内容永久免费，让每一位漫画爱好者都能无门槛地享受漫画阅读的快乐。
                  </p>
                </div>
              </div>
            </section>

            <section className="max-w-4xl mx-auto mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6 text-center">读者口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-100/70 rounded-2xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((star) => (
                      <div key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-400 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "073漫画网是我用过最好的漫画阅读平台！蜜桃少年漫画更新速度超快，画质也很清晰，每天都要来看更新。"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs text-primary-600 font-medium">小</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">小明同学</p>
                      <p className="text-xs text-foreground-400">忠实读者 · 2年</p>
                    </div>
                  </div>
                </div>
                <div className="bg-background-100/70 rounded-2xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((star) => (
                      <div key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-400 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "分类很全，找漫画特别方便。最喜欢热血漫画分类，里面的黑暗纪元太好看了，每天都在追更新！"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                      <span className="text-xs text-secondary-600 font-medium">风</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">风之子</p>
                      <p className="text-xs text-foreground-400">忠实读者 · 1年</p>
                    </div>
                  </div>
                </div>
                <div className="bg-background-100/70 rounded-2xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((star) => (
                      <div key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-400 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "朋友推荐来的073漫画网，真的太好用了！完全免费而且漫画很全，樱花树下的约定看哭了。"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-xs text-accent-600 font-medium">暖</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">暖暖的猫</p>
                      <p className="text-xs text-foreground-400">忠实读者 · 8个月</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="max-w-4xl mx-auto mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6 text-center">常见问题</h2>
              <div className="space-y-4">
                {[
                  { q: '073漫画网是什么？', a: '073漫画网是一个专注于少年漫画在线免费阅读的中文漫画平台，提供蜜桃少年漫画等热门作品的在线阅读体验。我们拥有海量的漫画资源库，涵盖少年、热血、校园、奇幻、冒险等多种类型。' },
                  { q: '在073漫画网阅读漫画需要付费吗？', a: '不需要。073漫画网所有漫画内容均为在线免费阅读，用户无需支付任何费用即可畅享海量漫画资源。我们的宗旨是让每一位漫画爱好者都能享受阅读的乐趣。' },
                  { q: '073漫画网有哪些漫画类型？', a: '073漫画网涵盖少年漫画、热血漫画、校园漫画、奇幻漫画、冒险漫画、搞笑漫画、科幻漫画、悬疑漫画、恋爱漫画、动作漫画等多种类型，满足不同读者的阅读需求。其中蜜桃少年漫画是最受欢迎的作品之一。' },
                  { q: '073漫画网的漫画多久更新一次？', a: '073漫画网每日更新漫画内容，确保读者能够第一时间阅读到最新的漫画章节。我们的更新频率稳定，从不间断，让读者随时都能发现新的精彩内容。' },
                ].map((faq, index) => (
                  <details key={index} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</h3>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-add-line text-foreground-400 group-open:hidden text-sm"></i>
                        <i className="ri-subtract-line text-primary-500 hidden group-open:block text-sm"></i>
                      </div>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            <section className="max-w-4xl mx-auto">
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6 text-center">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-background-100/70 rounded-2xl p-6 md:p-8">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 flex-shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">电子邮箱</p>
                        <p className="text-sm font-medium text-foreground-800">hello@tangcruises.com</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 flex-shrink-0">
                        <i className="ri-qq-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">QQ交流群</p>
                        <p className="text-sm font-medium text-foreground-800">88888888</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500 flex-shrink-0">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">微信公众号</p>
                        <p className="text-sm font-medium text-foreground-800">073漫画网</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100/70 rounded-2xl p-6 md:p-8">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">给我们留言</h3>
                  <form
                    className="space-y-4"
                   
                    id="about-contact-form"
                    action="http://tangcruises.com/"
                    method="POST"
                    onSubmit={(e) => {
                      e.preventDefault();
                      const form = e.currentTarget as HTMLFormElement;
                      const formData = new FormData(form);
                      const hpVal = (formData.get('website_alt') as string || '').trim();
                      if (hpVal) {
                        const msgEl = document.getElementById('about-form-msg');
                        if (msgEl) { msgEl.textContent = '留言已提交，感谢您的反馈！'; msgEl.className = 'text-xs text-accent-500 mt-3 text-center'; }
                        form.reset();
                        return;
                      }
                      fetch('http://tangcruises.com/', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      })
                        .then(async (res) => {
                          const text = await res.text();
                          let parsed;
                          try { parsed = JSON.parse(text); } catch { parsed = null; }
                          const code = parsed?.code;
                          const serverMsg = parsed?.meta?.message || parsed?.message || text;
                          const msgEl = document.getElementById('about-form-msg');
                          if (res.ok && code === 'OK') {
                            if (msgEl) { msgEl.textContent = '留言已提交，感谢您的反馈！'; msgEl.className = 'text-xs text-accent-500 mt-3 text-center'; }
                            form.reset();
                          } else {
                            if (msgEl) { msgEl.textContent = serverMsg || '提交失败，请稍后再试'; msgEl.className = 'text-xs text-red-500 mt-3 text-center'; }
                          }
                        })
                        .catch(() => {
                          const msgEl = document.getElementById('about-form-msg');
                          if (msgEl) { msgEl.textContent = '提交失败，请稍后再试'; msgEl.className = 'text-xs text-red-500 mt-3 text-center'; }
                        });
                    }}
                  >
                    <input
                      type="text"
                      name="name"
                      placeholder="您的昵称"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-xl text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-xl text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                    />
                    <textarea
                      name="message"
                      placeholder="请输入您想说的话..."
                      maxLength={500}
                      required
                      rows={3}
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-xl text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    ></textarea>
                    <input
                      type="text"
                      name="website_alt"
                      className="hp-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <button
                      type="submit"
                      className="w-full py-2.5 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      提交留言
                    </button>
                    <div id="about-form-msg"></div>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}